import apiService from './apiService';

const TOKEN = 'token';
const USER = 'user';

export const getToken = () => {
    return window.localStorage.getItem(TOKEN);
};

export const getUser = () => {
    return JSON.parse(window.localStorage.getItem(USER))?.user;
};

export const saveToken = (token) => {
    window.localStorage.setItem(TOKEN, token);
};

export const saveUser = (user) => {
    window.localStorage.setItem(USER, JSON.stringify(user));
};

export const logout = async (token) => {
    try {
        const response = await apiService.post('/logout',{},
            {
                headers: { Authorization: `Bearer ${token}`,},
            }
        );
        return response;
    } catch (error) {
        console.error('Logout API error:', error);
        throw new Error(error?.response.data?.message);
    }
};

export const loginApi = async (email, password,deviceOS) => {
    try {
        const response = await apiService.post(`/login`, { email: email, password: password,deviceOS });
        return response;
    } catch (error) {
        throw new Error(error?.response.data?.message);
    }
};
